import { render, staticRenderFns } from "./AutomationsMenu.vue?vue&type=template&id=08ebfe33&scoped=true&"
import script from "./AutomationsMenu.vue?vue&type=script&lang=js&"
export * from "./AutomationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsMenu.vue?vue&type=style&index=0&id=08ebfe33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebfe33",
  null
  
)

export default component.exports